(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wros-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function root(el) { return el.closest('.wl'); }

  function unitCents(r) {
    var sel = r.querySelector('[data-wl-variant]');
    var src = sel ? sel.options[sel.selectedIndex] : r.querySelector('input[data-wl-price-cents]');
    return src ? parseInt(src.getAttribute('data-wl-price-cents'), 10) : 0;
  }

  function fmt(r, cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: r.getAttribute('data-currency') || 'USD'
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function update(r) {
    var qtyEl = r.querySelector('[data-wl-qty]');
    var qty = Math.max(1, Math.min(9, parseInt(qtyEl.value, 10) || 1));
    qtyEl.value = qty;
    var unit = unitCents(r);
    r.querySelectorAll('[data-wl-total]').forEach(function (n) { n.textContent = fmt(r, unit * qty); });
    r.querySelectorAll('[data-wl-total-static]').forEach(function (n) { n.textContent = fmt(r, unit); });
    var price = r.querySelector('[data-wl-price]');
    if (price) price.textContent = fmt(r, unit);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wl-thumb]');
    if (t) {
      var r = root(t), i = t.getAttribute('data-wl-thumb');
      r.querySelectorAll('[data-wl-frame]').forEach(function (f) { f.hidden = f.getAttribute('data-wl-frame') !== i; });
      r.querySelectorAll('[data-wl-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
      return;
    }
    var dec = e.target.closest('[data-wl-dec]');
    var inc = e.target.closest('[data-wl-inc]');
    if (dec || inc) {
      var rr = root(dec || inc), q = rr.querySelector('[data-wl-qty]');
      q.value = (parseInt(q.value, 10) || 1) + (inc ? 1 : -1);
      update(rr);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-wl-qty], [data-wl-variant]')) update(root(e.target));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
